export default () => ({
  wines: [
    {
      id: 100001,
      name: 'Riesling',
      vintage: '2018',
      winegrower: 'Burg Ravensburg',
      region: 'Baden, Kraichgau',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100002,
      name: 'Spätburgunder Rosé',
      vintage: '2018',
      winegrower: 'Jesuitenhof',
      region: 'Pfalz',
      type: 'rs',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100003,
      name: 'Cuvée Vielfalt trocken',
      vintage: '2018',
      winegrower: 'Weingut Bamberger',
      region: 'Nahe',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100004,
      name: 'Cuvée Rosé trocken DQ',
      vintage: '2018',
      winegrower: 'Staatsweingut Weinsberg',
      region: 'Württemberg',
      type: 'rs',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100005,
      name: 'Inauris trocken IGT',
      vintage: '2015',
      winegrower: 'Casa Vinicola Sartori',
      region: 'Verona',
      type: 'r',
      country: 'Italien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100006,
      name: 'Pfälzer Federweißer',
      vintage: '2019',
      winegrower: 'Weingut Rosenhof',
      region: 'Pfalz',
      type: 'w',
      country: 'Deutschland',
      size: '1,0 L-Flasche',
    },
    {
      id: 100007,
      name: 'Tessellae Carignan Vieilles Vignes IGP',
      vintage: '2017',
      winegrower: 'Domaine Lafage',
      region: 'Perpignan',
      type: 'r',
      country: 'Frankreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100008,
      name: 'Riesling Kabinett trocken',
      vintage: '2018',
      winegrower: 'Peterhoff',
      region: 'Rheingau',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100009,
      name: 'Château de Pennautier "Terroirs d\'Altitude"',
      vintage: '2018',
      winegrower: 'Vignobles Lorgeril',
      region: 'Cabardès AC',
      type: 'r',
      country: 'Frankreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100010,
      name: 'Comtesse de Saint-Pey',
      vintage: null,
      winegrower: 'Prodiffu - Terre de Vignerons, Landerrouat',
      region: 'Crémant de Bordeaux Brut AC',
      type: 's',
      country: 'Frankreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100011,
      name: 'Castillo De Almansa Roble DO',
      vintage: 2016,
      winegrower: 'Bodegas Piqueras',
      region: 'Kastilien-La Mancha',
      type: 'r',
      country: 'Spanien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100012,
      name: 'Novello IGT',
      vintage: 2019,
      winegrower: 'Villa Sandi',
      region: 'Venetto',
      type: 'r',
      country: 'Italien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100013,
      name: 'Riesling Jodocus DQ',
      vintage: 2017,
      winegrower: 'Weingut Toni Jost Hahnenhof, Bacherach',
      region: 'Mittelrhein',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100014,
      name: 'Grüner Veltliner',
      vintage: 2019,
      winegrower: 'Weingut Dürnberg, Falkenstein',
      region: 'Niederösterreich',
      type: 'w',
      country: 'Österreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100015,
      name: 'Cuvée Falko',
      vintage: 2019,
      winegrower: 'Weingut Dürnberg, Falkenstein',
      region: 'Niederösterreich',
      type: 'w',
      country: 'Österreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100016,
      name: 'Cuvée Boogie DQ',
      vintage: 2019,
      winegrower: 'Weingut Altenkirch, Lorch',
      region: 'Rheingau',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100017,
      name: 'Le Petit Berticot Sauvignon IGP Atlantique',
      vintage: 2019,
      winegrower: 'Les Vignerons de Berticot',
      region: 'Duras',
      type: 'w',
      country: 'Frankreich',
      size: '0,75 L-Flasche',
    },
    {
      id: 100018,
      name: 'Heitlinger Rosé DQ trocken',
      vintage: 2019,
      winegrower: 'Weingut Heitlinger',
      region: 'Kraichgau, Baden',
      type: 'rs',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100019,
      name: 'Riesling Kabinett trocken',
      vintage: 2019,
      winegrower: 'Weingut Villa Gutenberg',
      region: 'Rheingau',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100020,
      name: 'Rosé Sekt Brut',
      vintage: null,
      winegrower: 'Villa Sandi',
      region: 'Il Fresco',
      type: 's',
      country: 'Italien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100021,
      name: 'Scheurebe trocken Schlossböckelheim DQ',
      vintage: 2019,
      winegrower: 'Weingut Christian Bamberger',
      region: 'Bad Sobernheim, Nahe',
      type: 'w',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100022,
      name: 'Pinot Noir trocken DQ',
      vintage: 2018,
      winegrower: 'Weingut Mathias Gaul',
      region: 'Asselheim, Pfalz',
      type: 'r',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100023,
      name: 'Traluna IGT',
      vintage: 2018,
      winegrower: 'Villa Trasqua',
      region: 'Toskana',
      type: 'r',
      country: 'Italien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100024,
      name: 'Vino Nobile di Montepulciano DOCG',
      vintage: 2014,
      winegrower: 'Fattoria della Talosa',
      region: 'Toskana',
      type: 'r',
      country: 'Italien',
      size: '0,75 L-Flasche',
    },
    {
      id: 100025,
      name: 'Schloss Vaux Cuvée Brut',
      vintage: null,
      winegrower: 'Sektmanufaktur Schloss Vaux AG, Eltville',
      region: 'Rheingau',
      type: 's',
      country: 'Deutschland',
      size: '0,75 L-Flasche',
    },
    {
      id: 100026,
      name: 'Prieurs de St. Julien AOC',
      vintage: 2018,
      winegrower: 'Laudun Chusclan Vignerons (Maison Sinnae)',
      region: 'Côtes du Rhône',
      type: 's',
      country: 'Frankreich',
      size: '1L-Flasche',
    },
  ],
})
